import React from 'react'
import { Button, Typography } from '@paintscout/ui'
import { useTrialOverDashboard } from '../useTrialOverDashboard'
import StatCards from '../../shared/StatCards'
import { useTrialOverDashboardDesktopLayoutStyles } from './useTrialOverDashboardDesktopLayoutStyles'

export default function TrialOverDashboardDesktop() {
  const classes = useTrialOverDashboardDesktopLayoutStyles()
  const { isAdmin, handleSelectPlan } = useTrialOverDashboard()

  return (
    <div className={classes.root}>
      <div className={classes.whiteBackground} />
      <div className={classes.leftSection}>
        <div className={classes.leftSectionContent}>
          <Typography className={classes.heading}>
            <span className={classes.headingFirstLine}>
              <span className={classes.headingHighlight}>Your PaintScout trial is over,</span>
            </span>
            <span className={classes.headingSecondLine}>but it doesn&lsquo;t have to end here.</span>
          </Typography>
          {isAdmin && (
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSelectPlan}
              className={classes.button}
            >
              Select Plan
            </Button>
          )}
        </div>
      </div>
      <div className={classes.rightSection}>
        <StatCards classes={classes} />
      </div>
    </div>
  )
}
